import { render, staticRenderFns } from "./AvatarSelector.vue?vue&type=template&id=7f7b977a"
import script from "./AvatarSelector.vue?vue&type=script&lang=js"
export * from "./AvatarSelector.vue?vue&type=script&lang=js"
import style0 from "./AvatarSelector.vue?vue&type=style&index=0&id=7f7b977a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports